module.exports = __webpack_public_path__ + "img/shape-triangle.d6109ca1.svg";